var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 6.500000) scale(-1, 1) translate(-11.000000, -6.500000) "
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(15.799077, 6.452650) rotate(45.000000) translate(-15.799077, -6.452650) ",
    points: "11.3438057 2.31633595 20.2543479 2.31633595 20.2543479 6.3198626 20.2543479 10.5889643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.741723,6.61810271 L0,6.61810271"
  }))))));
};
export default SvgArrow;